module.exports = __webpack_public_path__ + "img/plastic_bag.2fefa08e.jpg";